import { v4 as uuidV4 } from 'uuid'

import { isValidEmail, detectValueDelimiter } from 'util/strings'

export function isAgentActive(agent) {
  if (!agent) return false
  return agent.hasAcceptedInvitation && !agent.archived
}

export function isAgentNotArchived(agent) {
  if (!agent) return false
  return !agent.archived
}

export const compareRole = (a, b, direction = 'ASC') => {
  // Role sort: the ASC order is the same as roles in the array (the order isn't alphabetical)
  const roles = ['owner', 'admin', 'agent']
  const roleAIndex = roles.indexOf(a.role?.toLowerCase())
  const roleBIndex = roles.indexOf(b.role?.toLowerCase())
  return direction === 'ASC' ? roleAIndex - roleBIndex : roleBIndex - roleAIndex
}

export const convertEmailsToAgents = (
  bulkEmails,
  { bulkRoleIsAdmin, agentIdPrefix = '' } = {}
) => {
  const users = []
  const delimiter = detectValueDelimiter(bulkEmails)
  const splitBulkEmails = bulkEmails.split(delimiter)
  splitBulkEmails.forEach(rawEmail => {
    const email = rawEmail.trim()
    if (email && isValidEmail(email)) {
      users.push({
        // we need to create unique ids for each agent since we will be saving multiple entities to pending store
        id: [agentIdPrefix, uuidV4()].filter(Boolean).join('-'),
        email,
        role: bulkRoleIsAdmin ? 'admin' : 'agent',
      })
    }
  })
  return { users, splitBulkEmails }
}
